// extracted by mini-css-extract-plugin
export default {"container":"ThemeSwitch_container__ojw-Y"};